import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
  SelectFilter,
} from "../../shared/filters/types/filter";

const GROUP_BY_ID = "groupBy";

export function useGroupByFilter(): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = { filterId: GROUP_BY_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: GROUP_BY_ID,
      title: t("groupByTitleString"),
      options: [
        {
          value: "hfb",
          title: t("hfbString"),
        },
        {
          value: "slid",
          title: t("slidString"),
        },
        {
          value: "article",
          title: t("articleString"),
        },
      ],
      enabled: true,
      defaultValue,
    },
    t("noGroupingString")
  );
}
